import React from 'react';
import { ModalController } from '../../components/Modal/ControlledModal';
import { useChanges, Form } from '../../components/Form/Form';
import { Select } from '../../components/Form/Select/Select';
import { ServerScaling, createSchedule } from '../../model/server';
import { Datepicker } from '../../components/Form/Datepicker/Datepicker';
import { handleError } from '../../model/notification';
import { Button } from '../../components/Button/Button';
import { t } from '../../locales/translate';
import { Stack } from '../../components/Stack/Stack';
import { Grid } from '../../components/Grid/Grid';

export function ScheduleForm({
  controller,
  reloadSchedules,
}: {
  controller: ModalController<{
    status: ServerScaling;
    on: Date;
  }>;
  reloadSchedules: () => void;
}): JSX.Element {
  const [, setChanges, model, trackChanges] = useChanges<{
    status: ServerScaling;
    on: Date;
  }>(controller.model);

  async function handleOnSubmit(): Promise<void> {
    try {
      await createSchedule(model);
      reloadSchedules();
      controller.close();
    } catch (error) {
      handleError(error);
    }
  }

  function setScheduleToNow(): void {
    setChanges({ ...model, on: new Date() });
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid,
        });
        return (
          <Stack>
            <Select
              required
              name="status"
              label={t.model.server.serverMode}
              options={[
                {
                  label: 'NORMAL',
                  value: 'NORMAL',
                },
                {
                  label: 'BOOST',
                  value: 'BOOST',
                },
              ]}
            ></Select>
            <Grid flex noWrap gap="sm" className="schedule-form__date">
              <Datepicker required name="on" label={t.model.server.activeOn} hourpicker></Datepicker>
              <Button title={t.general.now} type="secondary" onClick={setScheduleToNow}></Button>
            </Grid>
          </Stack>
        );
      }}
    </Form>
  );
}
